export const GATEWAYS = [
  {
    id: "selah-slate",
    number: "I",
    title: "Selah Slate",
    subtitle: "Stop. Restore. Rebuild.",
    description:
      "A free tool designed to assist you in erasing the financial burdens of the past. Open the web app to begin — meaningful restoration requires your active participation.",
    cta: "Open Selah Slate",
    href: "https://app.selahslate.com",
    status: "live",
    platforms: [
      {
        name: "Google Play",
        status: "available",
        href: "https://play.google.com/store/apps/details?id=com.selahandstone.selahslate&hl=en_US",
      },
      {
        name: "Windows",
        status: "available",
        href: "https://apps.microsoft.com/detail/9PJF6L5GH0TF",
      },
      {
        name: "Apple",
        status: "available",
        href: "https://apps.apple.com/us/app/selah-slate/id6779376823",
      },
    ],
  },
  {
    id: "selah-downloads",
    number: "II",
    title: "Selah Downloads",
    subtitle: "Pause. Listen. Receive.",
    description:
      "A spiritual guidance app for the moments when you receive divine direction — a quiet place to capture, reflect, and walk it out. Curated by a licensed minister.",
    cta: "Open Selah Downloads",
    href: "https://selahdownloads.com",
    status: "live",
    platforms: [
      {
        name: "Google Play",
        status: "available",
        href: "https://play.google.com/store/apps/details?id=com.selahdownloads.app&hl=en_US",
      },
      {
        name: "Windows",
        status: "available",
        href: "https://apps.microsoft.com/detail/9MW70M7BDLFK",
      },
      {
        name: "Apple",
        status: "available",
        href: "https://apps.apple.com/us/app/selah-downloads/id6797657014",
      },
    ],
  },
  {
    id: "selah-and-salt-home",
    number: "III",
    title: "Selah and Salt Home",
    subtitle: "Gather. Nourish. Preserve.",
    description:
      "The culinary hub for generational recipes, family relational wellness reports, and the art of the spiritual pause.",
    cta: "Gather at the Table",
    status: "coming-soon",
  },
  {
    id: "selah-and-stone-research",
    number: "IV",
    title: "Selah and Stone Research",
    subtitle: "Truth. Foundation. Forensics.",
    description:
      "Professional background screening and forensic due diligence for businesses, organizations, and individuals. Also home to Family Legacy Audits — our signature deep-dive diagnostic to identify breaches in your family's spiritual and structural legacy.",
    cta: "Start a Conversation",
    status: "coming-soon",
  },
  {
    id: "family-legacy-audits",
    number: "IV",
    title: "Family Legacy Audits",
    subtitle: "Audit your Foundation.",
    description:
      "Our signature deep-dive diagnostic to identify breaches in your family's spiritual and structural legacy.",
    cta: "Pre-Book Your Family Audit",
    status: "coming-soon",
    hidden: true,
  },
  {
    id: "omni-signing-services",
    number: "V",
    title: "Omni Signing Services",
    subtitle: "Accuracy. Integrity. Professionalism.",
    description:
      "A premier notary and loan signing service providing reliable, forensic-level attention to detail for life's most important documents. With an upcoming expansion into mortgage origination, we ensure your family's most important transitions are handled with uncompromising integrity.",
    cta: "Request a Signing",
    href: "https://omnisigningservices.com",
  },
];

export const INTEREST_LABELS = {
  "selah-and-stone-research": "Selah and Stone Research",
  "selah-and-salt-home": "Selah and Salt Home",
  "family-legacy-audits": "Family Legacy Audits",
  "selah-shift-book": "The Selah Shift (Book)",
  general: "General Inquiry",
  "selah-slate": "Selah Slate (legacy)",
  "selah-downloads": "Selah Downloads (legacy)",
};

export const SUCCESS_MESSAGES = {
  "selah-slate": {
    prompt:
      "The weight of the past doesn't have to stay. Leave your name and email — we'll save you a seat in the Selah Slate beta.",
    title: "Your slate is being prepared.",
    description:
      "We hand you the tools; the restoration is yours to walk. You'll be among the first we invite.",
    toast: "Welcome to the Selah Slate beta list.",
  },
  "selah-downloads": {
    prompt:
      "When the Spirit speaks, there should be a place to hold it. Leave your name and email and we'll find you when Selah Downloads opens.",
    title: "The channel is open.",
    description: "Until then — pause, listen, receive.",
    toast: "We'll find you when Selah Downloads opens.",
  },
  "selah-and-stone-research": {
    prompt:
      "Tell us a little about what needs to be uncovered. We'll meet you where the truth is needed most.",
    title: "Your inquiry is in good hands.",
    description:
      "A member of our research team will respond personally within one business day.",
    toast: "We've received your research inquiry.",
  },
  "selah-and-salt-home": {
    prompt:
      "There's always a place at the table. Leave your name and email and we'll send the first recipes, rhythms, and gatherings.",
    title: "Your seat at the table is saved.",
    description:
      "Warm, slow-simmered, and made to last — we'll find you when the first gathering is ready.",
    toast: "Your seat at the table is saved.",
  },
  "family-legacy-audits": {
    prompt:
      "Every home has a foundation. Share your name and email to pre-book your audit.",
    title: "Your pre-booking is received.",
    description:
      "Thank you for pausing to look honestly at the foundation. We'll reach out within one business day to confirm timing.",
    toast: "Your Family Legacy Audit is pre-booked.",
  },
  "selah-shift-book": {
    prompt:
      "The Work was done in the Selah. Leave your name and email to walk with us from manuscript to release.",
    title: "You'll walk with us from the Selah.",
    description:
      "Notes from the journey, early excerpts, and the first copies will find you here.",
    toast: "You're on the early-reader list.",
  },
  general: {
    prompt:
      "Not sure which door is yours? Share your name, email, and what's pressing on your heart.",
    title: "Your note has found us.",
    description:
      "We read every note personally and will respond within one business day.",
    toast: "Your note has found us.",
  },
};

export const LOGO_URL = "/logo.png";
